export enum PaymentProvider {
  ALFA = 'ALFA',
  ORC = 'ORC',
}
